import { render, staticRenderFns } from "./userInfoComponent.vue?vue&type=template&id=33948261"
import script from "./userInfoComponent.vue?vue&type=script&lang=js"
export * from "./userInfoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports